import React, { useState } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateNumberCounterTabData,numberCounterTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [numberOfColumns, setNumberOfColumns] = useState(Number(numberCounterTabData.number_of_columns));
    const [numberOfColumnsDropdownOpen, setNumberOfColumnsDropdownOpen] = useState(false);
    const [spaceBetweenCounters, setSpaceBetweenCounters] = useState(numberCounterTabData.space_between_counters);
    const [spaceBetweenCountersDropdownOpen, setSpaceBetweenCountersDropdownOpen] = useState(false);

    const [tabletNumberOfColumns, setTabletNumberOfColumns] = useState(Number(numberCounterTabData.tablet_number_of_columns));
    const [tabletNumberOfColumnsDropdownOpen, setTabletNumberOfColumnsDropdownOpen] = useState(false);
    const [tabletSpaceBetweenCounters, setTabletSpaceBetweenCounters] = useState(numberCounterTabData.tablet_space_between_counters);
    const [tabletSpaceBetweenCountersDropdownOpen, setTabletSpaceBetweenCountersDropdownOpen] = useState(false);

    const [phoneNumberOfColumns, setPhoneNumberOfColumns] = useState(Number(numberCounterTabData.phone_number_of_columns));
    const [phoneNumberOfColumnsDropdownOpen, setPhoneNumberOfColumnsDropdownOpen] = useState(false);
    const [phoneSpaceBetweenCounters, setPhoneSpaceBetweenCounters] = useState(numberCounterTabData.phone_space_between_counters);
    const [phoneSpaceBetweenCountersDropdownOpen, setPhoneSpaceBetweenCountersDropdownOpen] = useState(false);

    const [width, setWidth] = useState(numberCounterTabData.width);
    const [activeAlignmentSection, setActiveAlignmentSection] = useState(numberCounterTabData.position_alignment);

    // Handlers Number Of Columns Change
    const handleNumberOfColumnsChange = (columns) => {
        setNumberOfColumns(columns);
        updateNumberCounterTabData("number_of_columns", columns);
        setNumberOfColumnsDropdownOpen(false);
    };

    // Handlers Space Between Counters Change
    const handleSpaceBetweenCountersChange = (space) => {
        setSpaceBetweenCounters(space);
        updateNumberCounterTabData("space_between_counters", space);
        setSpaceBetweenCountersDropdownOpen(false);
    };

    // Handlers Tablet Number Of Columns Change
    const handleTabletNumberOfColumnsChange = (columns) => {
        setTabletNumberOfColumns(columns);
        updateNumberCounterTabData("tablet_number_of_columns", columns);
        setTabletNumberOfColumnsDropdownOpen(false);
    };

    // Handlers Tablet Space Between Counters Change
    const handleTabletSpaceBetweenCountersChange = (space) => {
        setTabletSpaceBetweenCounters(space);
        updateNumberCounterTabData("tablet_space_between_counters", space);
        setTabletSpaceBetweenCountersDropdownOpen(false);
    };


    // Handlers Phone Number Of Columns Change
    const handlePhoneNumberOfColumnsChange = (columns) => {
        setPhoneNumberOfColumns(columns);
        updateNumberCounterTabData("phone_number_of_columns", columns);
        setPhoneNumberOfColumnsDropdownOpen(false);
    };

    // Handlers Phone Space Between Counters Change
    const handlePhoneSpaceBetweenCountersChange = (space) => {
        setPhoneSpaceBetweenCounters(space);
        updateNumberCounterTabData("phone_space_between_counters", space);
        setPhoneSpaceBetweenCountersDropdownOpen(false);
    };

    // Handlers Width Change
    const handleWidthChange = (event) => {
        const value = event.target.value;
        setWidth(value);
        updateNumberCounterTabData("width", value);
    };

    // Handle Position Alignment change
    const handleActiveAlignmentInputChange = (event) => {
        setActiveAlignmentSection(event.target.value);
        updateNumberCounterTabData("position_alignment", event.target.value);
    };
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Layout</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Number Of Columns</span>
                            <div className="color-pikr-box" onClick={() => setNumberOfColumnsDropdownOpen(!numberOfColumnsDropdownOpen)}>
                                <em>{numberOfColumns}</em>
                                {numberOfColumnsDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {[1,2,3,4,5].map((columns) => (
                                            <li key={columns} onClick={() => handleNumberOfColumnsChange(columns)}>
                                                {columns}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Space Between Counters</span>
                            <div className="color-pikr-box" onClick={() => setSpaceBetweenCountersDropdownOpen(!spaceBetweenCountersDropdownOpen)}>
                                <em>{spaceBetweenCounters}</em>
                                {spaceBetweenCountersDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["0px","2px","10px","20px","30px","40px","50px"].map((space) => (
                                            <li key={space} onClick={() => handleSpaceBetweenCountersChange(space)}>
                                                {space}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("mobile_settings")}>Mobile Settings<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>

                    <div className="side-baar-box-header">
                        <div className="box-header-row bubble-text">
                            <span>Width (auto, px, %)</span>
                            <input name="width" type="text" value={width} onChange={handleWidthChange}/>
                        </div>
                    </div>

                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <p>Counter Elements Layout</p>
                            <div className="left-cnater-right-button">
                                <label className="card-radio-btn">
                                    <input type="radio" name="alignment_type" className="card-input-element d-none" value="left" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "left"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Left</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="alignment_type" className="card-input-element d-none" value="center" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "center"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Center</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="alignment_type" className="card-input-element d-none" value="right" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "right"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Right</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "mobile_settings" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Mobile Settings</span>
                        <div className="side-baar-box-header">
                            <span className="side_sm_title">Tablet</span>
                            <div className="box-header-row">
                                <span>Number Of Columns</span>
                                <div className="color-pikr-box" onClick={() => setTabletNumberOfColumnsDropdownOpen(!tabletNumberOfColumnsDropdownOpen)}>
                                    <em>{tabletNumberOfColumns}</em>
                                    {tabletNumberOfColumnsDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {[1,2,3,4,5].map((columns) => (
                                                <li key={columns} onClick={() => handleTabletNumberOfColumnsChange(columns)}>
                                                    {columns}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Space Between Counters</span>
                                <div className="color-pikr-box" onClick={() => setTabletSpaceBetweenCountersDropdownOpen(!tabletSpaceBetweenCountersDropdownOpen)}>
                                    <em>{tabletSpaceBetweenCounters}</em>
                                    {tabletSpaceBetweenCountersDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["0px","2px","10px","20px","30px","40px","50px"].map((space) => (
                                                <li key={space} onClick={() => handleTabletSpaceBetweenCountersChange(space)}>
                                                    {space}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <span className="side_sm_title">Phone</span>
                            <div className="box-header-row">
                                <span>Number Of Columns</span>
                                <div className="color-pikr-box" onClick={() => setPhoneNumberOfColumnsDropdownOpen(!phoneNumberOfColumnsDropdownOpen)}>
                                    <em>{phoneNumberOfColumns}</em>
                                    {phoneNumberOfColumnsDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {[1,2,3,4,5].map((columns) => (
                                                <li key={columns} onClick={() => handlePhoneNumberOfColumnsChange(columns)}>
                                                    {columns}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Space Between Counters</span>
                                <div className="color-pikr-box" onClick={() => setPhoneSpaceBetweenCountersDropdownOpen(!phoneSpaceBetweenCountersDropdownOpen)}>
                                    <em>{phoneSpaceBetweenCounters}</em>
                                    {phoneSpaceBetweenCountersDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["0px","2px","10px","20px","30px","40px","50px"].map((space) => (
                                                <li key={space} onClick={() => handlePhoneSpaceBetweenCountersChange(space)}>
                                                    {space}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default LayoutTab;